
































































































































import Vue from "vue";
// import { parse } from 'graphql';
export default Vue.extend({
  name: "maths",
  data() {
    return {
      improperFractionToTopHeavyFraction: true,
      topHeavyNumerator: null,
      wholeNumber: null,
      mixedNumerator: null,
      mixedDenominator: null,
      topHeavyDenominator: null
    };
  },
  methods: {
    convertToTopHeavy() {
      this.topHeavyNumeratorA();
      this.topHeavydenominator1();
    },
    convertToMixed() {
      this.wholeNumberA();
      this.mixedNumeratorA();
      this.mixedDenominator2A();
    },
    wholeNumberA() {
      // @ts-ignore
      this.wholeNumber = Math.abs(
        // @ts-ignore

        Math.floor(this.topHeavyNumerator / this.topHeavyDenominator)
      );
    },
    mixedNumeratorA() {
      // @ts-ignore
      this.mixedNumerator = Math.abs(
        // @ts-ignore

        this.topHeavyNumerator % this.topHeavyDenominator
      );
    },
    topHeavyNumeratorA() {
      // @ts-ignore
      this.topHeavyNumerator = Math.abs(
        // @ts-ignore
        this.wholeNumber * this.mixedDenominator + this.mixedNumerator
      );
    },
    mixedDenominator2A() {
      // @ts-ignore
      this.mixedDenominator = Math.abs(this.topHeavyDenominator);
    },
    topHeavydenominator1() {
      // @ts-ignore
      this.topHeavyDenominator = Math.abs(this.mixedDenominator);
    }
  }
});
